export const natwestPurposes = [
    "Service charge",
    "Reserves",
    "Communal heat network",
    "Major works",
    "Other",
];
export const natwestAdditionalDecisions = [
    "Not assessed",
    "None required",
    "Additional required",
    "Unsure",
];
export const natwestApplicationStages = [
    "Requirements review",
    "Preparing",
    "Submitted",
    "Acknowledged",
    "Further information required",
    "Awaiting opening",
    "Rejected",
    "Withdrawn",
];
export function natwestStandardName(buildingName, purpose) {
    return purpose === "Service charge"
        ? `${buildingName} - S/C`
        : `${buildingName} Reserves`;
}
export function natwestAccountMatches(purpose, bank) {
    return (bank.bank.trim().toLowerCase() === "natwest" &&
        bank.status === "Active" &&
        bank.current &&
        (purpose === "Service charge"
            ? bank.type === "Service charge"
            : purpose === "Reserves"
                ? bank.type === "Reserve"
                : bank.type === "Other client money"));
}
//# sourceMappingURL=natwest-account-plan.js.map